export default __webpack_public_path__ + "static/media/susan-desktop.543ddae9.webp";